import React, { useMemo, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import projectLogo from "../assets/Logo.png";
import developerLogo from "../assets/DeveloperLogo.svg";
import godrej1 from "../assets/Godrej1.png";
import godrej2 from "../assets/Godrej2.png";
import godrej3 from "../assets/Godrej3.png";
import godrej4 from "../assets/Godrej4.png";
import godrej5 from "../assets/Godrej5.png";
import godrej6 from "../assets/Godrej6.png";
import godrej7 from "../assets/Godrej7.png";
import qrImage from "../assets/QR.png";
import mapImage from "../assets/Map.png";
import {
  HomeIcon,
  CurrencyRupeeIcon,
  BuildingOffice2Icon,
  WifiIcon,
  PhotoIcon,
  MapPinIcon,
  ComputerDesktopIcon,
  ChevronLeftIcon,
  ChevronDownIcon,
  ChevronRightIcon,
  PlayIcon,
  Bars3Icon,
  XMarkIcon,
  PhoneIcon,
  HomeModernIcon,
  TrophyIcon,
  IdentificationIcon,
} from "@heroicons/react/24/solid";

const navItems = [
  { id: "home", label: "Home", icon: HomeIcon, homeOnly: true },
  { id: "price", label: "Price", icon: CurrencyRupeeIcon },
  { id: "sitefloorplan", label: "Floor Plan", icon: BuildingOffice2Icon },
  { id: "amenities", label: "Amenities", icon: WifiIcon },
  { id: "gallery", label: "Gallery", icon: PhotoIcon },
  { id: "location", label: "Location", icon: MapPinIcon },
  { id: "sitevisit", label: "Virtual Site Visit", icon: ComputerDesktopIcon },
];

const pricingRows = [
  { type: "2 & 3 BHK", area: "1125 - 1468 Sq.Ft", price: "₹ 1.78 Cr+* Onwards" },
  // { type: "4 BHK", area: "1649 - 2249 Sq.Ft", price: "Rs. 7.45 Cr. Onwards" },
  // { type: "5 BHK", area: "2532 Sq.Ft", price: "Rs. 12.25 Cr. Onwards" },
];

const floorPlans = [
  { label: "2 BHK", img: "https://www.dlf-west-park.in/img/3bhk.webp" },
  { label: "3 BHK", img: "https://www.dlf-west-park.in/img/4bhk.webp" },
  // { label: "5 BHK", img: "https://www.dlf-west-park.in/img/5bhk.webp" },
];

const amenities = [
  "Clubhouse",
  "Gym",
  "Co-working pods",
  "Library",
  "Salon",
  "Luxury Banquet Hall",
  "Creche",
  "Swimming Pool",
  "Dance Room",
  "Yoga Room",
  "Badminton Court",
  "Study Arena",
  "Garden",
];

const gallery = [
  godrej2,
  godrej3,
  godrej4,
  godrej5,
  godrej6,
  godrej7,
];

const faqs = [
  {
    q: "Where is GODREJ NURTURE located?",
    a: "GODREJ NURTURE is located on LBS Marg, Bhandup, Mumbai.",
  },
  {
    q: "What configurations are available at GODREJ NURTURE?",
    a: "GODREJ NURTURE offers well-designed 2 & 3 bed homes with deck options.",
  },
  {
    q: "What is the starting price of homes at GODREJ NURTURE?",
    a: "The starting price is ₹1.78 Cr+ for 2 & 3 bed homes.",
  },
  {
    q: "What are the connectivity advantages of GODREJ NURTURE?",
    a: "The project offers seamless connectivity with access to GMLR, Metro Station, EEH, and nearby railway stations.",
  },
  {
    q: "Who is the developer of GODREJ NURTURE?",
    a: "GODREJ NURTURE is developed by Godrej Properties.",
  },
];

const nearby = [
  "On LBS Marg",
  "Next to Upcoming GMLR: 2 min",
  "Metro station: 2 min",
  "Mins away from EEH",
  "Near Bhandup and Nahur Station",
  "Well connected to Central & Western Suburbs and Navi Mumbai",
];

const promiseItems = [
  { label: "Instant Call Back", icon: PhoneIcon },
  { label: "Free Site Visit", icon: HomeModernIcon },
  { label: "Unmatched Price", icon: TrophyIcon },
];

const buttonClass =
  "rounded-md bg-[#5d627d] px-5 py-2 text-base font-semibold text-white hover:bg-[#4f5368]";
const sectionClass = "mt-4 rounded-none bg-white p-4 shadow-sm md:rounded";
const webhookUrl =
  "https://script.google.com/macros/s/AKfycbxTrPUIKN5-vZAda8_PTCJ_Fdpry7a9P-SKrYNoXGuWIeRHnmb-AptkapEqihZdJiik2g/exec";

async function submitLeadForm({ name, email, phone, message, pageUrl }) {
  const payload = new URLSearchParams({
    name: name.trim(),
    email: email.trim(),
    phone: phone.trim(),
    message,
    campaignName: "GodrejNurtureBhandup-AS-MUMB-926638",
    pageUrl,
  });

  await fetch(webhookUrl, {
    method: "POST",
    mode: "no-cors",
    headers: {
      "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
    },
    body: payload.toString(),
  });
}

function RightSidebar({
  onOpenModal,
  formData,
  onFieldChange,
  onSubmit,
  isSubmitting,
}) {
  return (
    <aside className="hidden xl:fixed xl:right-0 xl:top-0 xl:z-40 xl:block xl:h-screen xl:w-[390px] xl:overflow-y-auto xl:border-l xl:border-slate-300 xl:bg-white xl:p-4">
      <div className="overflow-hidden rounded-xl bg-black">
        <div>
          <button
            type="button"
            onClick={onOpenModal}
            className="flex w-full items-center justify-center gap-2 px-3 py-3.5 text-lg font-semibold text-white"
          >
            <span className="grid h-11 w-11 place-items-center rounded-full bg-slate-100 text-[#5d627d] ring-1 ring-slate-300">
              <IdentificationIcon className="h-7 w-7" />
            </span>
            Pre Register
          </button>
        </div>
      </div>

      {/* <a
        href="tel:+919228170764"
        className="mx-auto mt-2 block w-fit rounded bg-[#5d627d] px-4 py-1.5 text-base font-semibold text-white"
      >
        +91 9228170764
      </a> */}

      <h3 className="mt-8 text-center text-base font-bold text-slate-900">
        Pre-Register here for Site Visit
      </h3>

      <form className="mt-7 space-y-4" onSubmit={onSubmit}>
        <input
          required
          value={formData.name}
          onChange={(e) => onFieldChange("name", e.target.value)}
          placeholder="Name"
          className="w-full border-b border-slate-300 bg-transparent px-2 py-3 text-base text-slate-600 outline-none"
        />
        <input
          type="email"
          required
          value={formData.email}
          onChange={(e) => onFieldChange("email", e.target.value)}
          placeholder="Email Address"
          className="w-full border-b border-slate-300 bg-transparent px-2 py-3 text-base text-slate-600 outline-none"
        />
        <div className="grid grid-cols-2 gap-2">
          <select
            value={formData.countryCode}
            onChange={(e) => onFieldChange("countryCode", e.target.value)}
            className="w-full border-b border-slate-300 bg-transparent px-2 py-3 text-base text-slate-700 outline-none"
          >
            <option>India (+91)</option>
            <option>United Arab Emirates (+971)</option>
            <option>United States (+1)</option>
          </select>
          <input
            required
            value={formData.phone}
            onChange={(e) => onFieldChange("phone", e.target.value)}
            placeholder="Mobile No"
            className="w-full border-b border-slate-300 bg-transparent px-2 py-3 text-base text-slate-600 outline-none"
          />
        </div>
        <label className="flex items-start gap-3 text-sm leading-6 text-slate-800">
          <input type="checkbox" defaultChecked className="mt-1 h-5 w-5" />
          <span>
            I Consent to the Processing of Provided Data According to Privacy Policy |
            Terms & Conditions, I Authorize Horizon Proptech Pvt Ltd and its
            representatives to Call, SMS, Email or WhatsApp Me About Its Products and
            Offers. This Consent Overrides Any Registration For DNC/NDNC.
          </span>
        </label>
        <button
          type="submit"
          disabled={isSubmitting}
          className="mx-auto mt-3 block rounded-xl bg-[#5d627d] px-5 py-2 text-base font-semibold text-white"
        >
          {isSubmitting ? "Submitting..." : "Enquiry Now"}
        </button>
      </form>
    </aside>
  );
}

function Home() {
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState("home");
  const [faqOpen, setFaqOpen] = useState(-1);
  const [galleryStart, setGalleryStart] = useState(0);
  const galleryTouchStartX = useRef(null);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [isBrochureOpen, setIsBrochureOpen] = useState(false);
  const [isSubmittingSidebar, setIsSubmittingSidebar] = useState(false);
  const [isSubmittingModal, setIsSubmittingModal] = useState(false);
  const [sidebarForm, setSidebarForm] = useState({
    name: "",
    email: "",
    countryCode: "India (+91)",
    phone: "",
  });
  const [modalForm, setModalForm] = useState({
    name: "",
    email: "",
    countryCode: "India (+91)",
    phone: "",
  });

  const handleSidebarFieldChange = (field, value) => {
    setSidebarForm((prev) => ({ ...prev, [field]: value }));
  };

  const handleModalFieldChange = (field, value) => {
    setModalForm((prev) => ({ ...prev, [field]: value }));
  };

  const handleSidebarSubmit = async (e) => {
    e.preventDefault();
    if (isSubmittingSidebar) return;
    setIsSubmittingSidebar(true);
    try {
      await submitLeadForm({
        name: sidebarForm.name,
        email: sidebarForm.email,
        phone: `${sidebarForm.countryCode} ${sidebarForm.phone}`,
        message: "Hi, I am interested in Godrej Nurture. Please share more details.",
        pageUrl: window.location.href,
      });
      setSidebarForm({
        name: "",
        email: "",
        countryCode: "India (+91)",
        phone: "",
      });
      navigate("/thank-you");
    } finally {
      setIsSubmittingSidebar(false);
    }
  };

  const handleModalSubmit = async (e) => {
    e.preventDefault();
    if (isSubmittingModal) return;
    setIsSubmittingModal(true);
    try {
      await submitLeadForm({
        name: modalForm.name,
        email: modalForm.email,
        phone: `${modalForm.countryCode} ${modalForm.phone}`,
        message: "Hi, I am interested in Godrej Nurture. Please share more details.",
        pageUrl: window.location.href,
      });
      setModalForm({
        name: "",
        email: "",
        countryCode: "India (+91)",
        phone: "",
      });
      setIsBrochureOpen(false);
      navigate("/thank-you");
    } finally {
      setIsSubmittingModal(false);
    }
  };

  const visibleGallery = useMemo(() => {
    const out = [];
    for (let i = 0; i < 3; i += 1) {
      out.push(gallery[(galleryStart + i) % gallery.length]);
    }
    return out;
  }, [galleryStart]);

  const goToPrevGallery = () => {
    setGalleryStart((p) => (p - 1 + gallery.length) % gallery.length);
  };

  const goToNextGallery = () => {
    setGalleryStart((p) => (p + 1) % gallery.length);
  };

  const handleGalleryTouchStart = (e) => {
    galleryTouchStartX.current = e.touches[0]?.clientX ?? null;
  };

  const handleGalleryTouchEnd = (e) => {
    if (galleryTouchStartX.current === null) return;
    const touchEndX = e.changedTouches[0]?.clientX;
    if (typeof touchEndX !== "number") {
      galleryTouchStartX.current = null;
      return;
    }
    const deltaX = galleryTouchStartX.current - touchEndX;
    const swipeThreshold = 40;

    if (deltaX > swipeThreshold) {
      goToNextGallery();
    } else if (deltaX < -swipeThreshold) {
      goToPrevGallery();
    }

    galleryTouchStartX.current = null;
  };

  return (
    <div className="bg-white">
      <RightSidebar
        onOpenModal={() => setIsBrochureOpen(true)}
        formData={sidebarForm}
        onFieldChange={handleSidebarFieldChange}
        onSubmit={handleSidebarSubmit}
        isSubmitting={isSubmittingSidebar}
      />

      <header className="fixed left-0 right-0 top-0 z-50 border-b border-slate-300 bg-white shadow-sm xl:right-[390px]">
        <div className="flex items-stretch bg-white">
          <a href="#home" className="grid w-[160px] place-items-center bg-white px-1 py-1 md:w-[250px]">
            <img
              src={projectLogo}
              alt="The Westpark"
              className="h-[52px] w-[220px] object-contain"
            />
          </a>
          <div className="ml-auto grid place-items-center px-2 lg:hidden">
            <button
              type="button"
              onClick={() => setIsMobileMenuOpen((p) => !p)}
              className="rounded-md border border-slate-300 bg-[#f4f4f4] p-2.5 text-slate-700"
              aria-label="Toggle menu"
            >
              {isMobileMenuOpen ? (
                <XMarkIcon className="h-6 w-6" />
              ) : (
                <Bars3Icon className="h-6 w-6" />
              )}
            </button>
          </div>
          <nav className="hidden min-w-0 flex-1 overflow-x-auto lg:flex">
            {navItems.map((item) => {
              const Icon = item.icon;
              return (
                <a
                  key={item.id}
                  href={`#${item.id}`}
                  onClick={() => setActiveTab(item.id)}
                  className={`inline-flex items-center whitespace-nowrap border-l border-slate-300 px-3 py-2 text-sm font-medium ${activeTab === item.id
                    ? "bg-[#5d627d] text-white"
                    : "bg-[#f5f5f5] text-slate-900"
                    }`}
                  aria-label={item.label}
                >
                  {item.homeOnly ? (
                    <Icon className="h-4 w-4" />
                  ) : (
                    <span className="flex items-center gap-2">
                      <Icon className="h-4 w-4" />
                      <span>{item.label}</span>
                    </span>
                  )}
                </a>
              );
            })}
            <img
              src={developerLogo}
              alt="Horizon Proptech"
              className="h-[54px] w-[170px] border-l border-slate-300 object-contain"
            />
          </nav>
        </div>
        {isMobileMenuOpen && (
          <nav className="border-t border-slate-200 bg-white lg:hidden">
            <div className="grid grid-cols-1">
              {navItems.map((item) => {
                const Icon = item.icon;
                return (
                  <a
                    key={`m-${item.id}`}
                    href={`#${item.id}`}
                    onClick={() => {
                      setActiveTab(item.id);
                      setIsMobileMenuOpen(false);
                    }}
                    className={`inline-flex items-center justify-center gap-1 border-b border-slate-200 px-2 py-2 text-xl font-medium ${activeTab === item.id
                      ? "bg-[#5d627d] text-white"
                      : "bg-white text-slate-900"
                      }`}
                    aria-label={item.label}
                  >
                    <Icon className="h-4 w-4" />
                    {!item.homeOnly && <span>{item.label}</span>}
                  </a>
                );
              })}
              <div className="grid place-items-center border-b border-slate-200 py-2">
                <img
                  src={developerLogo}
                  alt="Horizon Proptech"
                  className="h-[52px] w-auto object-contain"
                />
              </div>
            </div>
          </nav>
        )}
      </header>

      <main className="px-3 pb-8 pt-[72px] lg:pt-[62px] xl:pr-[402px]">
        <section id="home" className="relative -mx-3 overflow-hidden rounded-none bg-white shadow-sm md:mx-0 md:rounded">
          <img
            src={godrej1}
            alt="DLF West Park"
            className="h-[260px] w-full object-cover md:h-[500px] lg:h-[660px]"
          />

          <div className="relative z-10 mx-0 -mt-10 w-auto overflow-hidden rounded-none bg-[white] shadow-lg sm:mx-3 sm:w-[340px] md:rounded-xl lg:absolute lg:left-3 lg:top-3 lg:mx-0 lg:mt-0 lg:w-[325px] lg:rounded-xl xl:w-[380px]">
            <div className="w-full bg-gradient-to-r from-[#5d627d] to-[#7b819f] py-3 text-center text-base font-semibold text-white">
              Booking Open: Limited Time Only
            </div>
            <div className="px-5 py-4 text-center">
              <h1 className="text-3xl font-bold">Godrej Nurture</h1>
              <p className="mt-1 text-base">
                At Bhandup <span className="font-semibold">By Godrej Properties</span>
              </p>
            </div>
            <div className="bg-[#d3d3d5] px-5 py-3 text-base">
              {/* <p className="flex justify-between">
                <span>Land Area</span>
                <span className="font-semibold">5.60-acre land parcel</span>
              </p> */}
              <p className="mt-1 flex justify-between">
                <span>Possession</span>
                <span className="font-semibold">Under Construction</span>
              </p>
            </div>
            <div className="p-4">

              <p className="mt-6 text-center text-base font-semibold">
                2 and 3 BHK Luxury Residence
              </p>
              <p className="mt-1 text-center text-3xl font-bold">₹ 1.78 Cr+* Onwards</p>
              <button
                type="button"
                onClick={() => setIsBrochureOpen(true)}
                className="mx-auto mt-4 block rounded-xl bg-[#5d627d] px-5 py-2 text-base font-semibold text-white"
              >
                Enquire Now
              </button>
            </div>
          </div>
        </section>

        <section id="overview" className={sectionClass}>
          <h2 className="text-4xl font-semibold text-[#445579]">Welcome To Godrej Nurture</h2>
          <p className="mt-3 text-base leading-relaxed">
            Embrace the colours of this festive season at GODREJ NURTURE on LBS Marg, Bhandup.
            Well- deisgned 2 & 3 bed homes with curated amenities for your family closer to conveniences.
            Discover a sanctuary designed for the entire family. Located strategically on LBS Marg near the upcoming Goregaon-Mulund Link Road, this address ensures seamless access to premium schools, hospitals, retail hubs, and corporate parks, drastically cutting down your commute. From expansive green landscapes and a lavish clubhouse to specialized child-centric amenities, it offers an elevated lifestyle where every generation can thrive and connect daily.
          </p>
          <button
            type="button"
            onClick={() => setIsBrochureOpen(true)}
            className={`${buttonClass} mt-4 block mx-auto md:mx-0`}
          >
            Download Brochure
          </button>
        </section>

        <section id="price" className={sectionClass}>
          <h2 className="text-3xl font-meadium text-[#445579]">Price Of Godrej Nurture</h2>

          <div className="mt-4 space-y-2 lg:hidden">
            {pricingRows.map((row, idx) => (
              <div
                key={`m-${row.type}`}
                className={`border border-slate-200 p-3 text-center ${idx % 2 === 0 ? "bg-[#d9d9dc]" : "bg-[#efeff1]"
                  }`}
              >
                <h3 className="text-2xl font-bold text-slate-800">{row.type}</h3>
                {/* <p className="mt-2 text-lg text-slate-700">
                  {row.area}
                  <span className="text-sm">(Carpet Area)</span>
                </p> */}
                <p className="mt-1 text-2xl font-bold text-slate-800">{row.price}</p>
                <button
                  type="button"
                  onClick={() => setIsBrochureOpen(true)}
                  className="mt-3 rounded bg-[#5d627d] px-5 py-2 text-base font-semibold text-white"
                >
                  Price Breakup
                </button>
              </div>
            ))}
          </div>

          <div className="mt-5 hidden gap-6 lg:grid lg:grid-cols-[2fr_1fr]">
            <div className="overflow-x-auto">
              <table className="w-full border-collapse text-base">
                <thead>
                  <tr className="bg-[#efefef]">
                    <th className="border border-slate-300 px-4 py-3 text-left">Type</th>
                    {/* <th className="border border-slate-300 px-4 py-3 text-left">Carpet Area</th> */}
                    <th className="border border-slate-300 px-4 py-3 text-left">Price</th>
                    <th className="border border-slate-300 px-4 py-3 text-left" />
                  </tr>
                </thead>
                <tbody>
                  {pricingRows.map((row) => (
                    <tr key={row.type} className="bg-[#d1d1d3]">
                      <td className="border border-slate-300 px-4 py-3">{row.type}</td>
                      {/* <td className="border border-slate-300 px-4 py-3">{row.area}</td> */}
                      <td className="border border-slate-300 px-4 py-3">{row.price}</td>
                      <td className="border border-slate-300 px-4 py-3">
                        <button
                          type="button"
                          onClick={() => setIsBrochureOpen(true)}
                          className="rounded bg-[#5d627d] px-5 py-1.5 text-base font-semibold text-white"
                        >
                          Price Breakup
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
            <div className="hidden overflow-hidden rounded border-[8px] border-[#5d627d] lg:block">
              <div className="group relative">
                <img
                  src="https://www.dlf-west-park.in/shared_template/img/costingdetails.webp"
                  alt="Costing details"
                  className="h-full w-full object-cover"
                />
                <div className="pointer-events-none absolute inset-0 bg-black/0 transition duration-300 group-hover:bg-black/70" />
                <button
                  type="button"
                  onClick={() => setIsBrochureOpen(true)}
                  className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 border border-white px-7 py-2.5 text-base font-medium tracking-wide text-white opacity-0 transition duration-300 group-hover:opacity-100"
                >
                  ENQUIRE NOW
                </button>
              </div>
              <div className="bg-gradient-to-r from-[#5d627d] to-[#6f7593] py-2 text-center text-sm font-medium text-white">
                Complete Costing Detail
              </div>
            </div>
          </div>
        </section>

        <section id="sitefloorplan" className={sectionClass}>
          <h2 className="text-3xl font-meadium text-[#445579]">Site &amp; Floor Plan Of Godrej Nurture</h2>
          <div className="mt-6 grid gap-5 md:grid-cols-2 lg:grid-cols-3">
            {floorPlans.map((plan) => (
              <article key={plan.label} className="overflow-hidden border-[8px] border-[#5d627d] bg-white">
                <div className="group relative">
                  <img src={plan.img} alt={plan.label} className="h-[185px] w-full object-cover p-1" />
                  <div className="pointer-events-none absolute inset-0 bg-black/0 transition duration-300 group-hover:bg-black/70" />
                  <button
                    type="button"
                    onClick={() => setIsBrochureOpen(true)}
                    className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 border border-white px-6 py-2 text-base font-medium text-white opacity-0 transition duration-300 group-hover:opacity-100"
                  >
                    ENQUIRE NOW
                  </button>
                </div>
                <div className="bg-gradient-to-r from-[#5d627d] to-[#6f7593] py-2 text-center text-base font-semibold text-white">
                  {plan.label}
                </div>
              </article>
            ))}
          </div>
        </section>

        <section id="amenities" className={sectionClass}>
          <div className="flex flex-col gap-3 md:flex-row md:items-center md:justify-between">
            <h2 className="text-3xl font-meadium text-[#445579]">Amenities Of Godrej Nurture</h2>
            <button type="button" onClick={() => setIsBrochureOpen(true)} className={`${buttonClass} self-center md:self-auto`}>
              Download Amenities
            </button>
          </div>
          <div className="mt-5 rounded-none border border-slate-300 p-5 md:rounded-lg">
            <div className="grid gap-y-4 md:grid-cols-2">
              {amenities.map((item) => (
                <p key={item} className="text-base font-medium">
                  <ChevronRightIcon className="mr-2 inline-block h-5 w-5 align-[-2px] text-black" />
                  {item}
                </p>
              ))}
            </div>
          </div>
        </section>

        <section id="gallery" className={sectionClass}>
          <div className="flex flex-col gap-3 md:flex-row md:items-center md:justify-between">
            <h2 className="text-3xl font-meadium text-[#445579]">Gallery Of Godrej Nurture</h2>
            <button type="button" onClick={() => setIsBrochureOpen(true)} className={`${buttonClass} self-center md:self-auto`}>
              Download Gallery
            </button>
          </div>

          <div
            className="relative mt-5 lg:hidden"
            onTouchStart={handleGalleryTouchStart}
            onTouchEnd={handleGalleryTouchEnd}
            style={{ touchAction: "pan-y" }}
          >
            <button
              type="button"
              onClick={goToPrevGallery}
              className="absolute left-2 top-1/2 z-10 -translate-y-1/2 rounded-full bg-[#5d627d] px-3.5 py-2.5 text-base text-white"
            >
              <ChevronLeftIcon className="h-5 w-5" />
            </button>
            <img
              src={gallery[galleryStart]}
              alt="Gallery"
              className="aspect-square w-full rounded-none object-cover md:rounded"
            />
            <button
              type="button"
              onClick={goToNextGallery}
              className="absolute right-2 top-1/2 z-10 -translate-y-1/2 rounded-full bg-[#5d627d] px-3.5 py-2.5 text-base text-white"
            >
              <ChevronRightIcon className="h-5 w-5" />
            </button>
          </div>

          <div className="relative mt-5 hidden lg:block">
            <button
              type="button"
              onClick={goToPrevGallery}
              className="absolute left-[-8px] top-1/2 z-10 -translate-y-1/2 rounded-full bg-[#5d627d] px-3.5 py-2.5 text-base text-white"
            >
              <ChevronLeftIcon className="h-5 w-5" />
            </button>
            <div className="grid gap-4 md:grid-cols-2 lg:grid-cols-3">
              {visibleGallery.map((img) => (
                <img key={img} src={img} alt="Gallery" className="aspect-square w-full rounded object-cover" />
              ))}
            </div>
            <button
              type="button"
              onClick={goToNextGallery}
              className="absolute right-[-8px] top-1/2 z-10 -translate-y-1/2 rounded-full bg-[#5d627d] px-3.5 py-2.5 text-base text-white"
            >
              <ChevronRightIcon className="h-5 w-5" />
            </button>
          </div>
        </section>

        <section id="location" className={sectionClass}>
          <div className="flex flex-col gap-3 md:flex-row md:items-center md:justify-between">
            <h2 className="text-3xl font-meadium text-[#445579]">Address Of Godrej Nurture</h2>
            <button type="button" onClick={() => setIsBrochureOpen(true)} className={`${buttonClass} self-center md:self-auto`}>
              Get Locations
            </button>
          </div>
          <div className="mt-4 grid gap-6 lg:grid-cols-2">
            <div>
              <h3 className="text-xl font-bold">Map View</h3>
              <div className="mt-3 overflow-hidden border-[8px] border-[#5d627d]">
                <img src={mapImage} alt="DLF West Park map" className="h-[320px] w-full object-cover" loading="lazy" />
              </div>
            </div>
            <div>
              <h3 className="pt-10 text-base font-bold lg:pt-14">Near By Location</h3>
              <ul className="mt-4 space-y-3 text-base">
                {nearby.map((item) => (
                  <li key={item} className="flex items-center gap-2">
                    <MapPinIcon className="h-5 w-5 text-red-600" />
                    <span>{item}</span>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </section>        <section id="sitevisit" className={sectionClass}>
          <h2 className="text-3xl font-meadium text-[#445579]">Virtual Tour Request</h2>
          <div className="relative mt-4 overflow-hidden">
            <img
              src={godrej1}
              alt="Virtual Site Visit"
              className="h-[360px] w-full object-cover"
            />
            <div className="absolute inset-x-0 top-1/2 -translate-y-1/2 bg-black/50 py-5 text-center text-white">
              <button
                type="button"
                onClick={() => setIsBrochureOpen(true)}
                className="mx-auto mb-2 grid h-20 w-20 place-items-center rounded-full bg-white"
                aria-label="Open virtual tour enquiry form"
              >
                <PlayIcon className="h-9 w-9 translate-x-0.5 text-slate-700" />
              </button>
              <h3 className="hidden text-4xl font-bold uppercase tracking-wide md:block">Virtual Site Visit</h3>
              <p className="hidden text-3xl md:block">Godrej Nurture</p>
            </div>
          </div>
        </section>

        <section id="developer" className={sectionClass}>
          <img
            src={projectLogo}
            alt="DLF West Park"
            className="mx-auto h-[60px] w-auto"
          />
          <h2 className="mt-3 text-xl font-bold">About Godrej Properties</h2>
          <p className="mt-3 text-base leading-relaxed">
            Godrej Properties is one of India's leading real estate developers, known for blending innovation and sustainability in its residential and commercial projects. Backed by the trusted Godrej Group, the company delivers thoughtfully designed spaces that reflect modernity, luxury, and eco-conscious living. With a strong presence across major cities, Godrej Properties offers a wide range of properties, from premium apartments to expansive townships, ensuring quality, innovation, and customer satisfaction in every project.
          </p>
          <p className="mt-4 text-base text-center md:text-left">
            This project is RERA registered{" "}
            <a
              href="https://maharera.maharashtra.gov.in"
              target="_blank"
              rel="noreferrer"
              className="text-[#111b6d]"
            >
              maharera.maharashtra.gov.in
            </a>
          </p>
          <h3 className="mt-6 text-base font-bold text-center md:text-left">RERA Information</h3>
          <img
            src={qrImage}
            alt="RERA QR"
            className="mx-auto mt-2 h-[90px] w-[190px] object-cover md:mx-0"
          />
          <p className="mt-2 text-base font-semibold text-center md:text-left">PR1180002501743, PR1180002501764</p>
        </section>

        <section className={sectionClass}>
          <h2 className="text-3xl font-meadium text-[#445579]">FAQs - Godrej Nurture</h2>
          <div className="mt-5 space-y-3">
            {faqs.map((faq, idx) => (
              <div key={faq.q} className="overflow-hidden rounded-none bg-[#f1f1f3] shadow-sm md:rounded-2xl">
                <button
                  type="button"
                  onClick={() => setFaqOpen((p) => (p === idx ? -1 : idx))}
                  className="flex w-full items-center justify-between px-6 py-[18px] text-left text-base font-semibold"
                >
                  <span>{faq.q}</span>
                  <ChevronDownIcon className="h-5 w-5" />
                </button>
                {faqOpen === idx && (
                  <p className="border-t border-slate-300 px-5 py-4 text-sm">{faq.a}</p>
                )}
              </div>
            ))}
          </div>
        </section>

        <section className={`${sectionClass} text-sm leading-relaxed`}>
          <ul className="list-disc space-y-2 pl-5">
            <li>Project Registered under Government of India RERA Act 2016 | maharera.maharashtra.gov.in</li>
            <li>Site Address : Nane Pada, Mulund East Mumbai, Maharashtra 400081</li>
            <li>Project&apos;s RERA Registration No.: PR1180002501743, PR1180002501764</li>
          </ul>
          <p className="mt-3 text-center">
            Copyright © 2026
          </p>
        </section>
      </main>

      {isBrochureOpen && (
        <div className="fixed inset-0 z-[100] grid place-items-center overflow-y-auto bg-black/60 p-3">
          <div className="relative w-full max-w-[560px] overflow-hidden rounded-none bg-[#efeff1] shadow-2xl md:rounded-md">
            <button
              type="button"
              onClick={() => setIsBrochureOpen(false)}
              className="absolute right-2 top-2 grid h-9 w-9 place-items-center rounded-full border-2 border-white bg-[#5d627d] text-white"
              aria-label="Close brochure modal"
            >
              <XMarkIcon className="h-4 w-4" />
            </button>

            <div className="bg-gradient-to-r from-[#5d627d] to-[#7b819f] px-4 py-3 text-center text-2xl font-bold text-white md:text-3xl">
              Download Brochure
            </div>

            <div className="grid gap-3 p-3 md:grid-cols-[180px_1fr]">
              <div className="hidden rounded-xl bg-[#e8e8ea] p-4 md:block">
                <h3 className="text-2xl leading-none text-[#445579]">We Promise</h3>
                <div className="mt-5 space-y-4">
                  {promiseItems.map((item) => {
                    const Icon = item.icon;
                    return (
                      <div key={item.label} className="text-center">
                        <Icon className="mx-auto h-6 w-6 text-slate-800" />
                        <p className="mt-1 text-xs text-slate-800">{item.label}</p>
                      </div>
                    );
                  })}
                </div>
              </div>

              <div className="px-1 pb-1">
                <img
                  src={projectLogo}
                  alt="The Westpark"
                  className="mx-auto h-[48px] w-[210px] object-contain"
                />
                <p className="mt-2 text-center text-lg font-semibold text-slate-800 md:text-xl">
                  Enquire Now For More Details !!
                </p>

                <form className="mt-3 space-y-3" onSubmit={handleModalSubmit}>
                  <input
                    required
                    value={modalForm.name}
                    onChange={(e) => handleModalFieldChange("name", e.target.value)}
                    placeholder="Name"
                    className="w-full border-b border-slate-300 bg-transparent px-2 py-1.5 text-sm text-slate-600 outline-none placeholder:text-slate-500"
                  />
                  <input
                    type="email"
                    required
                    value={modalForm.email}
                    onChange={(e) => handleModalFieldChange("email", e.target.value)}
                    placeholder="Email Address"
                    className="w-full border-b border-slate-300 bg-transparent px-2 py-1.5 text-sm text-slate-600 outline-none placeholder:text-slate-500"
                  />
                  <div className="grid grid-cols-2 gap-2">
                    <select
                      value={modalForm.countryCode}
                      onChange={(e) => handleModalFieldChange("countryCode", e.target.value)}
                      className="w-full border-b border-slate-300 bg-transparent px-2 py-1.5 text-sm text-slate-700 outline-none"
                    >
                      <option>India (+91)</option>
                      <option>United Arab Emirates (+971)</option>
                      <option>United States (+1)</option>
                    </select>
                    <input
                      required
                      value={modalForm.phone}
                      onChange={(e) => handleModalFieldChange("phone", e.target.value)}
                      placeholder="Mobile No"
                      className="w-full border-b border-slate-300 bg-transparent px-2 py-1.5 text-sm text-slate-600 outline-none placeholder:text-slate-500"
                    />
                  </div>
                  <label className="flex items-start gap-2 text-[11px] leading-4 text-slate-800">
                    <input type="checkbox" defaultChecked className="mt-0.5 h-4 w-4" />
                    <span>
                      I consent to the processing of my provided data in accordance with the Privacy Policy and Terms & Conditions. I authorize the service provider and its representatives to contact me via call, SMS, email, or WhatsApp regarding products and offers. This consent overrides any DNC/NDNC registration.
                    </span>
                  </label>
                  <button
                    type="submit"
                    disabled={isSubmittingModal}
                    className="mx-auto block rounded-md bg-[#5d627d] px-7 py-2 text-lg font-semibold text-white hover:bg-[#4f5368]"
                  >
                    {isSubmittingModal ? "Submitting..." : "Enquiry Now"}
                  </button>
                </form>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default Home;

